/**
 * NLB-GW
 *
 * Contact: service@rheinenergie.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * email address of a person or business
 */
export interface EmailIdentifier { 
    addressId?: string;
    /**
     * Email address
     */
    smtpAddress?: string;
    isDefault?: boolean;
}

